import { rtkOrgClient } from '@gm-commercial/rtk-clients';
import type { OrganizationMinViewDto } from '@gm-commercial/rtk-clients/organizations/types';

export type OrganizationTenantsState = {
  /** Every top-level organization; empty until the request resolves. */
  tenants: OrganizationMinViewDto[];
  /** True until the first response lands. */
  isLoading: boolean;
  isError: boolean;
};

const NO_TENANTS: OrganizationMinViewDto[] = [];

/**
 * Fetches the top-level organizations (tenants) from the org RTK client.
 * @returns The tenants with the request's loading and error state
 */
export const useOrganizationTenants = (): OrganizationTenantsState => {
  const { data, isLoading, isError } =
    rtkOrgClient.useGetTopLevelOrganizationsQuery();

  return {
    tenants: data?.result ?? NO_TENANTS,
    isLoading,
    isError,
  };
};
